let err_code = {
    'C100': {en: 'Not found value of error message!', vi: 'Không tìm thấy giá trị của message lỗi'},
    'C101': {en: 'You do not have permission!', vi: 'Bạn không có quyền!'},
    'C102': {en: 'Invalid json value', vi: 'Giá trị json không hợp lệ!'},
    'C103': {en: 'Oops! Something is wrong!', vi: 'Đã có lỗi xảy ra!'},
    'C104': {en: 'Category is required', vi: 'Bắt buộc truyền loại sự kiện!'},
    'C105': {en: 'Title is required', vi: 'Bắt buộc truyền tiêu đề sự kiện!'},
    'C106': {en: 'Start time is required', vi: 'Bắt buộc truyền thời gian bắt đầu!'},
    'C107': {en: 'End time is required', vi: 'Bắt buộc truyền thời gian kết thúc!'},
    'C108': {en: 'Status is required', vi: 'Bắt buộc truyền trạng thái!'},
    'C109': {en: 'Location address is required', vi: 'Bắt buộc truyền Địa chỉ của địa điểm!'},
    'C110': {en: 'Location name is required', vi: 'Bắt buộc truyền Tên địa điểm!'},
    'C111': {en: 'Location code is required', vi: 'Bắt buộc truyền Mã địa điểm!'},
    'C112': {en: 'Invalid sort param', vi: 'Tham số lọc không hợp lệ!'},
    'C113': {en: 'Not found entity', vi: 'Không tìm thấy phần tử!'},
    'C114': {en: 'Duplicate entity', vi: 'Phần tử đã trùng!'},
    'C115': {en: 'UserId is required', vi: 'Bắt buộc truyền userId!'},
    'C116': {en: 'Username is required', vi: 'Bắt buộc truyền tên đăng nhập!'},
    'C117': {en: '', vi: ' truyền vào không hợp lệ!'},
    'C118': {en: 'Not found recipient in calendar', vi: 'Không tìm thấy người tham gia trong cuộc họp!'},
    'C119': {en: 'Start time must be before end time', vi: 'Thời gian bắt đầu phải xảy ra trước thời gian kết thúc!'},
    'C120': {en: 'Only update calendar has status A', vi: 'Chỉ cập nhật lịch họp có trạng thái Active!'},
    'C121': {en: 'Category name is required', vi: 'Bắt buộc truyền loại sự kiện!'},
    'C122': {en: 'Category code is required', vi: 'Bắt buộc truyền mã loại sự kiện!'},
    'C123': {en: 'Category source is required', vi: 'Bắt buộc truyền Nguồn loại sự kiện!'},
    'C124': {en: 'Invalid DateTime format (yyyy-MM-dd HH:mm:ss)', vi: 'Định dạng thời gian truyền vào không hợp lệ!'},
    'C125': {en: '', vi: 'Không tồn tại người dùng '},
    'C126': {en: 'Only allows 1 owner', vi: 'Chỉ cho phép một cuộc họp có 1 owner!'},
    'C127': {en: 'Can\'t create a calendar in the past', vi: 'Không thể tạo cuộc họp trong quá khứ!'}
}
  

let errorCode = function (code, message) {
    try {
        if (typeof localStorage !== 'undefined') {
            let language = localStorage.getItem('netaLang') || 'vi'
            language = language.replace(/"/g, '')
            
            if (err_code[code] && typeof(err_code[code]) == 'object') {
                if (language === 'en') {
                    return err_code[code]['en'] || message
                } else if (language === 'vi') {
                    if (code === 'C117') {
                        let messageStr = message.replace('Invalid ', '').replace(' value', '')
                        return messageStr + err_code[code]['vi']
                    } else if (code === 'C125') {
                        let messageStr = message.replace('Not existed user ', '')
                        return err_code[code]['vi'] + messageStr
                    } else {
                        return err_code[code]['vi']
                    }
                } else {
                    return message
                }
            } else {
                return message
            }  
        }
    } catch(e) {
        return 'Error'
    }
}


export default errorCode